const STORAGE_VERSION = 1;
const STORAGE_PREFIX = '@7Cantos:kanbanFilterPrefs';

export type KanbanFilterPreferencesPayload = {
  search: string;
  selectedColumns: number[];
  fieldValues: Record<string, unknown>;
};

type StoredShape = {
  v: number;
  search: string;
  selectedColumns: number[];
  fieldValues: Record<string, unknown>;
};

function key(boardId: number): string {
  return `${STORAGE_PREFIX}:v${STORAGE_VERSION}:${boardId}`;
}

export function loadKanbanFilterPreferences(
  boardId: number | undefined
): KanbanFilterPreferencesPayload | null {
  if (!boardId || Number.isNaN(boardId)) return null;
  try {
    const raw = localStorage.getItem(key(boardId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredShape;
    if (!parsed || parsed.v !== STORAGE_VERSION) return null;
    return {
      search: typeof parsed.search === 'string' ? parsed.search : '',
      selectedColumns: Array.isArray(parsed.selectedColumns)
        ? parsed.selectedColumns.map(Number).filter(n => !Number.isNaN(n))
        : [],
      fieldValues:
        parsed.fieldValues && typeof parsed.fieldValues === 'object' && !Array.isArray(parsed.fieldValues)
          ? parsed.fieldValues
          : {},
    };
  } catch {
    return null;
  }
}

export function saveKanbanFilterPreferences(
  boardId: number | undefined,
  payload: KanbanFilterPreferencesPayload
): void {
  if (!boardId || Number.isNaN(boardId)) return;
  try {
    const stored: StoredShape = {
      v: STORAGE_VERSION,
      search: payload.search ?? '',
      selectedColumns: Array.isArray(payload.selectedColumns) ? payload.selectedColumns : [],
      fieldValues: payload.fieldValues ?? {},
    };
    localStorage.setItem(key(boardId), JSON.stringify(stored));
  } catch {
    
  }
}

export function clearKanbanFilterPreferences(boardId: number | undefined): void {
  if (!boardId || Number.isNaN(boardId)) return;
  try {
    localStorage.removeItem(key(boardId));
  } catch {
    
  }
}
